import React, { useState, useEffect, forwardRef } from "react";
import { useNavigate } from "react-router-dom";

// Service
import AziendaService from "../services/AziendeService"; // <-- MODIFICATO

// Material Table & Icons
import MaterialTable from 'material-table';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';

const AziendeList = (props) => {
    const username = props.user?.username || ''; // Usa optional chaining e un valore di fallback
    const [aziende, setAziende] = useState([]); // <-- MODIFICATO
    const user = props.user;
    const isAdmin = props.user?.roles?.includes("ROLE_ADMIN") || false;
    let navigate = useNavigate();

    // L'oggetto tableIcons rimane invariato
    const tableIcons = {
        Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
        Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
        Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
        Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
        DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
        Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
        Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
        Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
        FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
        LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
        NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
        PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
        ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
        Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
        SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
        ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
        ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
    };

    useEffect(() => {
        if (isAdmin) {
            retrieveAziende(); // Carica tutte le aziende per l'admin
        } else if (user && user.sede) {
            retrieveAziende(user.sede);
        }
        // Se non c'è una sede specifica, puoi decidere di non caricare nulla
        // o chiamare retrieveAziende() senza parametri per caricarli tutti.

        // ... (le altre chiamate come retrieveTables rimangono qui se necessario)
    }, [isAdmin, user]); // L'effetto si attiva quando l'oggetto 'user' cambia


    const retrieveAziende = (sede) => {
        AziendaService.getAll(sede) // <-- MODIFICATO
            .then(response => {
                setAziende(response.data); // <-- MODIFICATO
            })
            .catch(e => {
                console.log(e);
            });
    };

    const deleteAzienda = (id) => { // <-- MODIFICATO
        AziendaService.remove(id) // <-- MODIFICATO
            .then(response => {
                alert("Azienda cancellata"); // <-- MODIFICATO
                retrieveAziende(); // Ricarica i dati dopo la cancellazione
            })
            .catch(e => {
                console.log(e);
            });
    };

    return (
        <>
            {/* Il bottone ora aggiunge un'azienda */}
            <Button variant="contained" sx={{ marginBottom: "20px" }} startIcon={<AddIcon />} onClick={() => navigate("/dashboard/aziende/add")}>
                Aggiungi Azienda
            </Button >

            <MaterialTable
                columns={[
                    // Colonne specifiche per le aziende
                    { field: 'ragione_sociale', title: "Ragione Sociale" },
                    { field: 'partita_iva', title: "Partita IVA" },
                    { field: 'settore', title: "Settore" },
                    { field: 'nome_referente', title: "Nome Referente" },
                    { field: 'cognome_referente', title: "Cognome Referente" },
                    { field: 'email', title: "Email Azienda", hidden: true, hiddenByColumnsButton: true },
                    { field: 'telefono', title: "Telefono Azienda", hidden: true, hiddenByColumnsButton: true },
                    { field: 'email_referente', title: "Email Referente", hidden: true, hiddenByColumnsButton: true },
                    { field: 'telefono_referente', title: "Telefono Referente", hidden: true, hiddenByColumnsButton: true },
                    { field: 'indirizzo', title: "Indirizzo", hidden: true, hiddenByColumnsButton: true },
                    { field: 'comune', title: "Comune", hidden: true, hiddenByColumnsButton: true },
                    { field: 'provincia', title: "Provincia", hidden: true, hiddenByColumnsButton: true },
                ]}
                data={aziende} // <-- MODIFICATO
                title="Aziende"   // <-- MODIFICATO
                icons={tableIcons}
                options={{
                    // Le opzioni rimangono le stesse
                    exportButton: true,
                    exportAllData: true,
                    filtering: true,
                    columnsButton: true,
                    grouping: true,
                    pageSize: 20,
                    pageSizeOptions: [5, 10, 20, 50],
                    headerStyle: { fontSize: 16, fontWeight: "bold" },
                }}
                localization={{
                    // Localizzazione aggiornata per "azienda"
                    grouping: { placeholder: 'Trascina qui un campo colonna' },
                    pagination: {
                        labelDisplayedRows: '{from}-{to} di {count}',
                        labelRowsSelect: 'Righe',
                        firstAriaLabel: 'Prima pagina',
                        previousAriaLabel: 'Pagina precedente',
                        nextAriaLabel: 'Pagina successiva',
                        lastAriaLabel: 'Ultima pagina'
                    },
                    toolbar: {
                        searchTooltip: 'Cerca',
                        searchPlaceholder: 'Cerca',
                        exportTitle: 'Esporta',
                        showColumnsTitle: 'Mostra colonne',
                    },
                    header: { actions: 'Azioni' },
                    body: { emptyDataSourceMessage: 'Nessuna azienda trovata' } // <-- MODIFICATO
                }}
                actions={[
                    {
                        icon: tableIcons.Edit,
                        tooltip: 'Modifica Azienda',
                        onClick: (event, rowData) => {
                            // Naviga alla pagina di modifica specifica per l'azienda
                            navigate('/dashboard/aziende/' + rowData.id); // <-- MODIFICATO
                        }
                    }
                ]}
            />
        </>
    );
};

export default AziendeList;